<template>
  <div class="page-bar-wrapper">
    <v-container fluid class="page-bar-container px-4">
      <v-row class="child-flex">
        <div>
          <v-toolbar class="page-bar" dense light>
            <v-container>
              <v-row class="align-center">
                <v-toolbar-title class="section-intro-target">{{title}}</v-toolbar-title>

                <v-spacer></v-spacer>

                <slot name="actions:add">
                  <v-btn icon>
                    <v-icon color="primary" @click="handleNewAction">mdi-plus-circle</v-icon>
                  </v-btn>
                </slot>

              </v-row>
            </v-container>
          </v-toolbar>
        </div>
      </v-row>
    </v-container>
  </div>
</template>
<script>
// @ is an alias to /src
//import CategoryBreadCrumb from '@/components/CategoryBreadCrumb.vue'

export default {
  name: 'IndexPageBar',
  components: {
    //CategoryBreadCrumb
  },
  props: {
    title: String
  },
  methods: {
    handleNewAction: function () {
      this.$emit('onNew')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.page-bar-wrapper {
  &::after {
    content: "";
    display: block;
    height: $page-bar-height;
  }
}

.page-bar-container {
  padding: 0;
  position: fixed;
  z-index: 2;
  /*top: $nav-bar-height;*/
  left: 0;
  right: 0;

  .page-bar {
    box-shadow: none;
    border-bottom: 1px solid var(--v-info-lighten2) !important;
    /*padding-left: 20px;*/

    .v-toolbar__title {
      font-size: 1rem;
    }
  }
}
</style>
